﻿<template>
    <section v-if="context.show" class="info-block">
        <div class="icon">           
        </div>
      <div class="info-text">
        <span>{{context.message}}</span>
      </div>
      <div class="clearfix"></div>
    </section> 
</template>

<script>
  export default {
        name: 'ca-error-message',
        props: ['context']
    }
</script>
